import {AxiosResponse} from 'axios';
import {AnyAction} from 'redux';
import {ThunkAction} from 'redux-thunk';

import {reviewsFail, reviewsFetching, reviewsReceived} from '../../../actions/reviews';
import request from '../../../application/api/request';
import selectAlpenroseHost from '../../../entities/pageSetup/apiHosts/selectors/selectAlpenroseHost';
import {State} from '../../../store/initialState';


export default function fetchReviews(): ThunkAction<Promise<void | AxiosResponse<unknown>>, State, unknown, AnyAction> {
  return (dispatch, getState) => {
    const state = getState();
    const designId = parseInt(state.routingData?.routesParams?.designId, 10);

    dispatch(reviewsFetching());

    return request(state, {
      url: `${selectAlpenroseHost(state)}/reviews/design/${designId}`
    })
      .then((data) => {
        dispatch(reviewsReceived(data));

        return data;
      })
      // Any error that comes back from this request should be swallowed to avoid
      // showing a non-critical error to the user
      .catch(() => {
        dispatch(reviewsFail());
        Promise.resolve();
      });
  };
}
